
let language = {
    FILE_LIBRARY_UPLOAD_RESULT_UPLOAD_FILE_TITLE: "上传文件",
    FILE_LIBRARY_UPLOAD_RESULT_HEADER_IMAGE_NAME: "图像",
    FILE_LIBRARY_UPLOAD_RESULT_HEADER_IMAGE_INFO: "信息",
    FILE_LIBRARY_UPLOAD_RESULT_HEADER_FILE_STATUS: "状态",

    FILE_LIBRARY_UPLOAD_RESULT_FILE_NAME: "名称:",
    FILE_LIBRARY_UPLOAD_RESULT_FILE_TYPE: "类型:",
    FILE_LIBRARY_UPLOAD_RESULT_FILE_SIZE: "大小:",
    FILE_LIBRARY_UPLOAD_RESULT_UPLOAD_ERR_MSG: "信息:",

    FILE_LIBRARY_UPLOAD_RESULT_CLOSE_UPLOADING_MODAL_TIP: "上传文件，关闭后上传的文件会丢失！你确定要关闭上传模式吗?",

    // 
    FILE_LIBRARY_UPLOAD_RESULT_CONFIRM_BTN: "确认",
    FILE_LIBRARY_UPLOAD_RESULT_CANCEL_BTN: "取消",
    FILE_LIBRARY_UPLOAD_RESULT_UPLOAD_BTN: "上传",
    FILE_LIBRARY_UPLOAD_RESULT_OK_BTN: "确定",
    
    FILE_LIBRARY_UPLOAD_RESULT_STATUS_TYPE_SUCCESS: "成功",
    FILE_LIBRARY_UPLOAD_RESULT_STATUS_TYPE_FAIL: "失败",
    
    // 
    FILE_LIBRARY_UPLOAD_RESULT_FILE_FORMAT_NOT_SUPPORTED_TIP: "不支持此文件格式。(我们接受 {{variables}} 文件)",
    FILE_LIBRARY_UPLOAD_RESULT_FILE_NAME_NOT_SUPPORTED_TIP: '文件名不合法，文件名不能包含以下字符: \\ \/ \: \* \? \" \< \> \|',
    
    
};

export { language }